import { FC } from 'react';

import { UserAgreementPage } from 'Pages';

export const UserAgreementScreen: FC = () => {
  return <UserAgreementPage />;
};
